import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {environment} from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'amy-chat-bot',
  templateUrl: './amy-chat-bot.component.html',
  styleUrls: ['./amy-chat-bot.component.scss']
})
export class AmyChatBotComponent implements OnInit {

  constructor( @Inject(DOCUMENT) private document: Document, public route: Router) { }

  botpressServerUrl = environment.AMY_BOT_URL;
  showCards = false;
  showAllCards = true
  appName = 'amy';
  isAmyConnectFlow = false;
  appicationName = 'Amy'
  

  ngOnInit(): void {
    let self = this;
    if(self.route.url && self.route.url.includes('cms')) {
      this.appicationName = 'Amy CMS';
    } else if(self.route.url && self.route.url.includes('connect')) {
      this.isAmyConnectFlow = true;
      this.appicationName = 'Amy connect';
    } else if(self.route.url && self.route.url.includes('clockit')) {
      this.appicationName = 'Amy clockit'
    } else if(self.route.url && self.route.url.includes('collaboration')) {
      this.appicationName = 'Amy collaboration'
    }
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    if(windowHeight > 700) {
      this.showCards = true;
    }
    const script = document.createElement('script');
    script.src = environment.AMY_BOT_URL+'/assets/modules/channel-web/inject.js';
    script.onload = () => {
      window['botpressWebChat'].init(
        {
          host: environment.AMY_BOT_URL,
          botId: environment.AMY_BOT_ID,
          enableConversationDeletion: false,
          showPoweredBy: false,

          // Set the width of the WebChat container and layout to 100% (Full Screen)
          layoutWidth: '100%25',
          hideWidget: false,
          showCloseButton: false,
          disableAnimations: false,
          closeOnEscape: true,
          showConversationsButton: false,
          enableTranscriptDownload: false,
          enableReset: false,
          enablePersistHistory: true,
          showBotInfoButton: false,
          enableResetSessionShortcut: true,
          botName: 'Amy Bot',
          hasBotInfoDescription: false,
          botConvoDescription: null,
          enableVoiceComposer: false,
          showOverlayDivs: true,
          showScrollBar: true,
          // stylesheet:'https://webchat-styler-css.botpress.app/prod/code/3fcd3e4e-d5bc-4bf5-8699-14b621b3ada2/v31782/style.css',
          extraStylesheet: environment.AMY_BOT_URL+'/assets/modules/channel-web/amy-custom-style.css',
          // extraStylesheet :"https://webchat-styler-css.botpress.app/prod/code/7cff8abd-dc5e-4dc0-87b8-a4f2d5efe211/v60182/style.css"
        }
      )
    };
    document.head.appendChild(script);
    if(sessionStorage.getItem("cardsAlreadyLoaded")) {
      this.showAllCards = false
    }
    window.addEventListener("message", function(event) {
      if (event.data.name === 'webchatReady') {
        if(self.route.url && self.route.url.includes('cms')) {
          self.appName = 'amy-cms'
        } else if(self.route.url && self.route.url.includes('connect')) {
          self.appName = 'amy-connect'
        } else if(self.route.url && self.route.url.includes('clockit')) {
          self.appName = 'amy-clockit'
        } else if(self.route.url && self.route.url.includes('collaboration')) {
          self.appName = 'amy'
        }
        window['botpressWebChat'].sendPayload({ type: 'proactive-trigger', text: self.appName})
      }
    })
    function handleClickClient() {
      hideOverlayDivs();
      window['botpressWebChat'].mergeConfig({ botId: environment.AMY_BOT_ID })

      // window['botpressWebChat'].sendEvent({ type: "show" });

      // window.addEventListener("message", function (event) {
      //   if (event.data.name === "webchatReady") {
      //     window['botpressWebChat'].sendEvent({
      //       type: "proactive-trigger",
      //       channel: "web",
      //       payload: { text: "Hi, I am client" }
      //     })
      //     window['botpressWebChat'].sendPayload({ type: 'text', text: 'I am a message sent through code' })
      //   }
      // })
    }
    function handleClickSP() {
      //document.querySelector('.bpw-floating-button').click()

      hideOverlayDivs();
      window['botpressWebChat'].mergeConfig({ botId: environment.AMY_BOT_ID })

      // window['botpressWebChat'].sendEvent({ type: "show" });

      // window.addEventListener("message", function (event) {
      //   if (event.data.name === "webchatReady") {
      //     window['botpressWebChat'].sendEvent({
      //       type: "proactive-trigger",
      //       channel: "web",
      //       payload: { text: "Hi, I am service provider" }
      //     })
      //     window['botpressWebChat'].sendPayload({ type: 'text', text: 'I am a message sent through code' })
      //   }
      // })

    }

    function handleClickDownloadReport() {
      //document.querySelector('.bpw-floating-button').click()

      hideOverlayDivs();
      window['botpressWebChat'].mergeConfig({ botId: environment.AMY_BOT_ID })

      // window['botpressWebChat'].sendEvent({ type: "show" });

      // window.addEventListener("message", function (event) {
      //   if (event.data.name === "webchatReady") {
      //     window['botpressWebChat'].sendEvent({
      //       type: "proactive-trigger",
      //       channel: "web",
      //       payload: { text: "Download 2024 Insights for Global software services Industry" }
      //     })
      //   }
      // })

    }

    window.addEventListener("message", function (event) {
      if (event.data.name === "webchatOpened") {
        hideOverlayDivs()
      }
    })

    window.addEventListener("message", function (event) {
      if (event.data.name === "webchatClosed") {
        hideOverlayDivs()
      }
    })


    function hideOverlayDivs() {
      var overlayMsgDivs = document.querySelectorAll('.overlay-msg');
      // Loop through the selected elements and hide them
      overlayMsgDivs.forEach(function (div) {
        div['style'].display = 'none';
      });
      if (!sessionStorage.getItem('cardsAlreadyLoaded')) {
        sessionStorage.setItem('cardsAlreadyLoaded', 'true');
      }
    }

    function showOverlayDivs() {
      var overlayMsgDivs = document.querySelectorAll('.overlay-msg');
      // Loop through the selected elements and hide them
      setTimeout(() => {
        overlayMsgDivs.forEach(function (div) {
          div['style'].display = 'block';
        });
    }, 50);
      
    }

    const clientButton = document.getElementById('client');
    if(clientButton) {
      clientButton.addEventListener('click', handleClickClient);
    }
    const spButton = document.getElementById('service_provider');
    if(spButton) {
      spButton.addEventListener('click', handleClickSP);
    }
    function openChatModule() {
      hideOverlayDivs();
      window['botpressWebChat'].mergeConfig({ botId: environment.AMY_BOT_ID })
      window['botpressWebChat'].sendEvent({ type: "show" });
      // hideButton.addEventListener('click', function () {
      //   elementToHide.style.display = 'none';
      // });
    }
    function addMessageWithEmoji() {
      var chatContainer = document.getElementById("glad_to_see_help");
      if (chatContainer) {
        chatContainer.innerHTML = `<p>Glad to see you're checking out ${self.appicationName}. 😊</p> <p>Can i help you out with anything?</p>`;
      }
    }
    function cancelBtn() {
      var cancelBtn = document.getElementById("cancel_cross_btn");
      if (cancelBtn) {
        cancelBtn.innerHTML = `
        <div class="d-flex"> 
          <div class="close_icon">
            <svg width="29px" height="27px" viewBox="0 0 25.00 25.00" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#4f4f4f" stroke-width="0.00025" transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(7.375,7.375), scale(0.41)"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.15"></g><g id="SVGRepo_iconCarrier"> <path d="M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z" fill="#4f4f4f"></path> </g></svg>
          </div>
        </div>`;
      }
      if (cancelBtn) {
        cancelBtn.addEventListener('click', hideOverlayDivs);
      }
    }
    function cancelBtn2() {
      var cancelBtn = document.getElementById("cancel_cross_btn2");
      if (cancelBtn) {
        cancelBtn.innerHTML = `
        <div class="d-flex"> 
          <div class="close_icon">
            <svg width="29px" height="27px" viewBox="0 0 25.00 25.00" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#4f4f4f" stroke-width="0.00025" transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(7.375,7.375), scale(0.41)"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.15"></g><g id="SVGRepo_iconCarrier"> <path d="M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z" fill="#4f4f4f"></path> </g></svg>
          </div>
        </div>`;
      }
      if (cancelBtn) {
        cancelBtn.addEventListener('click', hideOverlayDivs);
      }
    }
    function cancelBtn3() {
      var cancelBtn = document.getElementById("cancel_cross_btn3");
      if (cancelBtn) {
        cancelBtn.innerHTML = `
        <div class="d-flex"> 
          <div class="close_icon">
            <svg width="29px" height="27px" viewBox="0 0 25.00 25.00" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#4f4f4f" stroke-width="0.00025" transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(7.375,7.375), scale(0.41)"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.15"></g><g id="SVGRepo_iconCarrier"> <path d="M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z" fill="#4f4f4f"></path> </g></svg>
          </div>
        </div>`;
      }
      if (cancelBtn) {
        cancelBtn.addEventListener('click', hideOverlayDivs);
      }
    }
    setTimeout(addMessageWithEmoji, 10000);
    function updateMessage() {
      var messageContainer = document.getElementById("client_content");
      if (messageContainer) {
        messageContainer.innerHTML = "Are you a service provider?";
      }
      var messageContainer = document.getElementById("service_provider_content");
      if (messageContainer) {
        messageContainer.innerHTML = "Outsource your requirement?";
      }
    }
    function setDownloadReport() {
      var messageContainer = document.getElementById("download_report");
      var htmlCode = `
            <div class="">
                <div class="d-flex" style="margin-bottom: 14px">
                    <div class="pdf">
                      <svg viewBox="-4 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M25.6686 26.0962C25.1812 26.2401 24.4656 26.2563 23.6984 26.145C22.875 26.0256 22.0351 25.7739 21.2096 25.403C22.6817 25.1888 23.8237 25.2548 24.8005 25.6009C25.0319 25.6829 25.412 25.9021 25.6686 26.0962ZM17.4552 24.7459C17.3953 24.7622 17.3363 24.7776 17.2776 24.7939C16.8815 24.9017 16.4961 25.0069 16.1247 25.1005L15.6239 25.2275C14.6165 25.4824 13.5865 25.7428 12.5692 26.0529C12.9558 25.1206 13.315 24.178 13.6667 23.2564C13.9271 22.5742 14.193 21.8773 14.468 21.1894C14.6075 21.4198 14.7531 21.6503 14.9046 21.8814C15.5948 22.9326 16.4624 23.9045 17.4552 24.7459ZM14.8927 14.2326C14.958 15.383 14.7098 16.4897 14.3457 17.5514C13.8972 16.2386 13.6882 14.7889 14.2489 13.6185C14.3927 13.3185 14.5105 13.1581 14.5869 13.0744C14.7049 13.2566 14.8601 13.6642 14.8927 14.2326ZM9.63347 28.8054C9.38148 29.2562 9.12426 29.6782 8.86063 30.0767C8.22442 31.0355 7.18393 32.0621 6.64941 32.0621C6.59681 32.0621 6.53316 32.0536 6.44015 31.9554C6.38028 31.8926 6.37069 31.8476 6.37359 31.7862C6.39161 31.4337 6.85867 30.8059 7.53527 30.2238C8.14939 29.6957 8.84352 29.2262 9.63347 28.8054ZM27.3706 26.1461C27.2889 24.9719 25.3123 24.2186 25.2928 24.2116C24.5287 23.9407 23.6986 23.8091 22.7552 23.8091C21.7453 23.8091 20.6565 23.9552 19.2582 24.2819C18.014 23.3999 16.9392 22.2957 16.1362 21.0733C15.7816 20.5332 15.4628 19.9941 15.1849 19.4675C15.8633 17.8454 16.4742 16.1013 16.3632 14.1479C16.2737 12.5816 15.5674 11.5295 14.6069 11.5295C13.948 11.5295 13.3807 12.0175 12.9194 12.9813C12.0965 14.6987 12.3128 16.8962 13.562 19.5184C13.1121 20.5751 12.6941 21.6706 12.2895 22.7311C11.7861 24.0498 11.2674 25.4103 10.6828 26.7045C9.04334 27.3532 7.69648 28.1399 6.57402 29.1057C5.8387 29.7373 4.95223 30.7028 4.90163 31.7107C4.87693 32.1854 5.03969 32.6207 5.37044 32.9695C5.72183 33.3398 6.16329 33.5348 6.6487 33.5354C8.25189 33.5354 9.79489 31.3327 10.0876 30.8909C10.6767 30.0029 11.2281 29.0124 11.7684 27.8699C13.1292 27.3781 14.5794 27.011 15.985 26.6562L16.4884 26.5283C16.8668 26.4321 17.2601 26.3257 17.6635 26.2153C18.0904 26.0999 18.5296 25.9802 18.976 25.8665C20.4193 26.7844 21.9714 27.3831 23.4851 27.6028C24.7601 27.7883 25.8924 27.6807 26.6589 27.2811C27.3486 26.9219 27.3866 26.3676 27.3706 26.1461ZM30.4755 36.2428C30.4755 38.3932 28.5802 38.5258 28.1978 38.5301H3.74486C1.60224 38.5301 1.47322 36.6218 1.46913 36.2428L1.46884 3.75642C1.46884 1.6039 3.36763 1.4734 3.74457 1.46908H20.263L20.2718 1.4778V7.92396C20.2718 9.21763 21.0539 11.6669 24.0158 11.6669H30.4203L30.4753 11.7218L30.4755 36.2428ZM28.9572 10.1976H24.0169C21.8749 10.1976 21.7453 8.29969 21.7424 7.92417V2.95307L28.9572 10.1976ZM31.9447 36.2428V11.1157L21.7424 0.871022V0.823357H21.6936L20.8742 0H3.74491C2.44954 0 0 0.785336 0 3.75711V36.2435C0 37.5427 0.782956 40 3.74491 40H28.2001C29.4952 39.9997 31.9447 39.2143 31.9447 36.2428Z" fill="#e81111"></path> </g></svg>
                    </div>
                    <div class="d-flex">
                      <div class="text">
                        <span style="font-weight: 600;">2024 Insights for Global software services Industry</span><br>
                        <span>Download this free report</span>
                      </div>
                    </div>
                </div>
                <div class="d-flex" style="margin-bottom: 10px">
                  <div class="" style="width: 42px;">
                  </div>
                  <div style="margin-bottom: 10px">
                    <span>Must read for</span> <br>
                    <span style="font-weight: 600;">Software services agencies</span>
                  </div>
                </div>
                <div class="download_report save-btn" style="align-items:center; font-size: 14px" id="download_report_btn"> Download Report </div>
            </div>
        `;
      if (messageContainer) {
        messageContainer.innerHTML = htmlCode;
      }
      const downloadReport = document.getElementById('download_report_btn');
      if (downloadReport) {
        downloadReport.addEventListener('click', handleClickDownloadReport);
      }
      // const closeReport = document.getElementById('close_icon');
      // if (closeReport) {
      //   closeReport.addEventListener('click', openChatModule);
      // }
    }
    setTimeout(function() {
      var cancelBtn = document.querySelector('.cancel_btn2');
      if (cancelBtn) {
        cancelBtn['style'].display = 'none';
      }
    }, 39999);
    setTimeout(setDownloadReport, 40000); // 10000 milliseconds = 10 seconds
    setTimeout(cancelBtn, 40000);
    setTimeout(cancelBtn2, 10000);
    if(!this.showCards) {
      setTimeout(cancelBtn3, 10000);
    }
    setTimeout(updateMessage, 10000); // 10000 milliseconds = 10 seconds
  }
}
